// extracted by mini-css-extract-plugin
module.exports = {"iconContainerClassName":"SquareIcon_iconContainerClassName__2a227","iconClassName":"SquareIcon_iconClassName__4USm4"};